import styled from 'styled-components';
import { sizing, spacing } from '@material-ui/system';
import {Grid as MuiGrid} from '@material-ui/core';

export const Grid = styled(MuiGrid)`
  ${sizing}
  ${spacing}
`;